import React, { useRef, useState } from "react";
import {
    Button,
    ButtonGroup,
    CircularProgress,
    Menu,
    MenuItem,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import PullDateRangeFields from "./PullDateRangeFields.jsx";
import { catalogQuietButtonSx } from "../Products/catalogGridStyles.js";

const groupSx = {
    "& .MuiButtonGroup-grouped": {
        ...catalogQuietButtonSx,
        minWidth: 0,
    },
    "& .MuiButtonGroup-grouped:not(:last-of-type)": {
        borderRightColor: "#e2e8f0",
    },
};

/**
 * Split control: primary click pulls all channels; arrow opens date range + channel options.
 */
export default function PullOrdersSplitButton({
    pulling = false,
    onPull,
    startDate,
    endDate,
    onStartChange,
    onEndChange,
    rangeError = "",
    hint = "",
    label = "Pull orders",
}) {
    const anchorRef = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    const runPull = (action) => {
        if (rangeError) return;
        closeMenu();
        onPull?.(action);
    };

    const handlePrimaryClick = () => {
        if (rangeError) {
            setMenuOpen(true);
            return;
        }
        onPull?.("all");
    };

    return (
        <>
            <ButtonGroup
                ref={anchorRef}
                size="small"
                variant="outlined"
                disabled={pulling}
                sx={groupSx}
            >
                <Button
                    startIcon={
                        pulling ? (
                            <CircularProgress size={14} />
                        ) : (
                            <SyncOutlinedIcon fontSize="small" />
                        )
                    }
                    onClick={handlePrimaryClick}
                >
                    {label}
                </Button>
                <Button
                    size="small"
                    aria-controls={menuOpen ? "pull-orders-menu" : undefined}
                    aria-expanded={menuOpen ? "true" : undefined}
                    aria-haspopup="menu"
                    aria-label="Pull orders options"
                    onClick={() => setMenuOpen((open) => !open)}
                    sx={{ px: 0.75 }}
                >
                    <ArrowDropDownIcon fontSize="small" />
                </Button>
            </ButtonGroup>
            <Menu
                id="pull-orders-menu"
                anchorEl={anchorRef.current}
                open={menuOpen}
                onClose={closeMenu}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                slotProps={{ paper: { sx: { minWidth: 300, px: 0.5, py: 0.5 } } }}
            >
                <PullDateRangeFields
                    startDate={startDate}
                    endDate={endDate}
                    onStartChange={onStartChange}
                    onEndChange={onEndChange}
                    error={rangeError}
                    hint={hint}
                />
                <MenuItem
                    disabled={Boolean(rangeError) || pulling}
                    onClick={() => runPull("all")}
                >
                    All channels
                </MenuItem>
                <MenuItem
                    disabled={Boolean(rangeError) || pulling}
                    onClick={() => runPull("ebay")}
                >
                    eBay
                </MenuItem>
                <MenuItem
                    disabled={Boolean(rangeError) || pulling}
                    onClick={() => runPull("walmart")}
                >
                    Walmart
                </MenuItem>
                <MenuItem
                    disabled={Boolean(rangeError) || pulling}
                    onClick={() => runPull("shopify")}
                >
                    Shopify
                </MenuItem>
            </Menu>
        </>
    );
}
